import type { ESQueryModel } from '@repo/api-codegen';
import { createContext } from 'react';

export interface QueryDrawerContextType {
	query: ESQueryModel | null;
	openQuery: (query: ESQueryModel | null) => void;
	opened: boolean;
	close: () => void;
}

export const defaultContext: QueryDrawerContextType = {
	query: null,
	openQuery: () => {},
	opened: false,
	close: () => {},
};

export const QueryDrawerContext =
	createContext<QueryDrawerContextType>(defaultContext);
